<template>
  <div class="mb-4">
    <!-- 1 deal = large -->
    <!-- <Deal :product="products[0]" :hasCountdown="hasCountdown" v-if="hasOnlyOneDeal"></Deal> -->

    <!-- even deals = all small -->
    <div class="columns is-multiline is-variable is-5" v-if="!hasOddDeals">
      <div class="column is-half-tablet avoid-break-inside  " v-for="product in products" :key="product.id">
        <DealSmall :product="product" :hasCountdown="hasCountdown" />
      </div>
    </div>

    <!-- odd deals = first large, others small -->
    <div v-if="hasOddDeals">
      <Deal :product="firstDeal" :hasCountdown="hasCountdown"></Deal>

      <div class="columns is-multiline is-variable is-5">
        <div class="column is-half-tablet avoid-break-inside " v-for="product in otherDeals" :key="product.id">
          <DealSmall :product="product" :hasCountdown="hasCountdown" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Deal from '@/components/Deal'
import DealSmall from '@/components/DealSmall'
export default {
  name: 'DealWrapper',
  components: {
    Deal,
    DealSmall,
  },
  props: {
    products: {
      type: Array,
    },
    hasCountdown: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      //hasOddDeals: false,
      //hasOnlyOneDeal: false,
      //firstDeal: {},
      //otherDeals: [],
    }
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        // this.updateDeals()
        this.$forceUpdate()
      }
    },
  },
  computed: {
    hasOddDeals: function() {
      return this.products.length % 2 != 0
    },
    hasOnlyOneDeal: function() {
      return this.products.length == 1
    },
    firstDeal: function() {
      return this.products[0]
    },
    otherDeals: function() {
      return this.products.slice(1)
    },
  },
  methods: {
    updateDeals() {
      // this.hasOddDeals = this.products.length % 2 != 0
      // this.hasOnlyOneDeal = this.products.length == 1
      //if (this.hasOddDeals) {
      // this.firstDeal = this.products[0]
      // this.otherDeals = this.products.slice(1)
    },
  },
  // beforeUpdate() {
  //   this.updateDeals()
  // },
}
</script>

<style lang="scss" scoped></style>
